/**
 * Colored initials chip identifying who added an agenda item.
 * Green for the supervisor, terracotta for the employee — mirrors the
 * RHYTHM color language everywhere else in the module.
 */
function initialsOf(name) {
  if (!name) return "??";
  const parts = String(name).trim().split(/\s+/);
  const first = (parts[0] || "").charAt(0);
  const last = (parts[parts.length - 1] || "").charAt(0);
  return (first + last).toUpperCase() || "??";
}

export default function AgendaAuthorChip({ name, isSupervisor, size = "sm" }) {
  const dim = size === "sm" ? "h-6 w-6 text-[10px]" : "h-8 w-8 text-xs";
  const cls = isSupervisor
    ? "bg-forest-900/10 text-forest-900"
    : "bg-terracotta-500/15 text-terracotta-600";
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-semibold shrink-0 ${dim} ${cls}`}
      title={name ? `Added by ${name}` : ""}
      data-testid="agenda-author-chip"
    >
      {initialsOf(name)}
    </span>
  );
}
